import React from 'react';

const Loading = () => {
	return (
		<div className="d-flex align-items-center justify-content-center my-5">
			<div className="spinner-border" role="status"></div>
		</div>
	);
};

export default React.memo(Loading);
